import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import registerServiceWorker from 'registerServiceWorker';
import App from 'App';
import 'theme/dist/theme.css';
import { initialize } from 'application';

const application = initialize();
if (application) {
	ReactDOM.render(
		<Provider store={application.store}>
			<Router history={application.history}>
				<App />
			</Router>
		</Provider>,
		document.getElementById('root') as HTMLElement,
	);
	registerServiceWorker();
}




// WEBPACK FOOTER //
// ./src/index.tsx